import api from './api';

export interface WeeklyReflection {
  id: string;
  user_id: string;
  week_start_date: string;
  week_end_date: string;
  topics_learned: string[];
  completed_tasks: string[];
  knowledge_gaps: string[];
  next_week_focus?: string;
  confidence_level: number;
  energy_level: number;
  notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface WeeklyReflectionCreate {
  week_start_date: string;
  week_end_date: string;
  topics_learned: string[];
  completed_tasks: string[];
  knowledge_gaps: string[];
  next_week_focus?: string;
  confidence_level: number;
  energy_level: number;
  notes?: string;
}

export interface WeeklyReflectionUpdate {
  topics_learned?: string[];
  completed_tasks?: string[];
  knowledge_gaps?: string[];
  next_week_focus?: string;
  confidence_level?: number;
  energy_level?: number;
  notes?: string;
}

class ReflectionsService {
  async getAll(): Promise<WeeklyReflection[]> {
    const response = await api.get('/reflections/');
    return response.data;
  }

  async getById(id: string): Promise<WeeklyReflection> {
    const response = await api.get(`/reflections/${id}`);
    return response.data;
  }

  async create(reflection: WeeklyReflectionCreate): Promise<WeeklyReflection> {
    const response = await api.post('/reflections/', reflection);
    return response.data;
  }

  async update(id: string, reflection: WeeklyReflectionUpdate): Promise<WeeklyReflection> {
    const response = await api.patch(`/reflections/${id}`, reflection);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/reflections/${id}`);
  }
}

export const reflectionsService = new ReflectionsService();

